module.exports = __webpack_public_path__ + "img/2.c200a0c0.jpg";